/**
 * --------------------------------------------------
 * Add event listeners to form elements for animation
 * @module forms
 * @see module:forms
 * --------------------------------------------------
 */

export default {

    selectedClassName: 'selected',

    dirtyClassName: 'isDirty',

    find: function (sel) {
        var _self = this;
        $(sel).on('focusin change', function (e) {
            $(e.currentTarget).addClass(_self.selectedClassName);
            _self.isEmpty($(e.currentTarget));
        });

        $(sel).on('focusout', function (e) {
            $(e.currentTarget).removeClass(_self.selectedClassName);
            _self.isEmpty($(e.currentTarget));
        });

        let interval = setInterval(function () {
            if ($('#Company').val() !== "") {
                $('#Company').parent().addClass(_self.dirtyClassName);
                clearInterval(interval);
            }
        }, 100);

        // check if inputs are prepopulated
        var $inputs = $(sel);
        for(var i = 0 ; i < $inputs.length; i++){
            this.isEmpty($($inputs[i]));
        }
    },

    isEmpty: function ($input) {
        /*if ( $input.find('select').length !== 0 && $.isEmptyObject($input.find('select').val())){
            $input.removeClass(this.dirtyClassName);
        }*/
        if ( $input.find('input').length !== 0 && $.isEmptyObject($input.find('input').val())) {
            $input.removeClass(this.dirtyClassName);
        }
        else {
            $input.addClass(this.dirtyClassName);
        }
    },
}
